import { v4 as uuid } from 'uuid';

/**
 * An helper to generate an unique id stored in the local storage.
 * Such ID stays the same until when the local storage is not erased.
 *
 * @param keySuffix A suffix used to generate an unique key to store the id. The name of the product may be a good choice
 * @returns An `IdGenerator` that can be passed to pico
 */
export const localStorageIdGenerator = (keySuffix: string): (() => string) => {
  if (typeof window === 'undefined') {
    throw new Error('This helper can only be used in web-based environments');
  }

  const itemKeyName = `LOCAL_STORAGE_ID_${keySuffix}`;

  return () => {
    const localStorageId = window.localStorage.getItem(itemKeyName);

    if (localStorageId == null) {
      const newLocalStorageId = uuid();
      window.localStorage.setItem(itemKeyName, newLocalStorageId);
      return newLocalStorageId;
    }

    return localStorageId;
  };
};

/**
 * Wrapper around `localStorageID` that allows to keep the same local storage id between Pico and Orion providers.
 */
export const picoXLocalStorageId = (): (() => Promise<string>) => {
  if (typeof window === 'undefined') {
    throw new Error('This helper can only be used in web-based environments');
  }

  return async () => {
    return localStorageIdGenerator('PICOX_ID')();
  };
};
